<template>
    <div class="row">
        <div class="col-12 mb-1">
            <label class="form-label">Firma Adı</label>
            <input class="form-control" v-model="value.FirmName" placeholder="Firma Adı" />
        </div>        
    </div>
</template>

<script>
export default {
    props:{
        value:Object
    },
    data(){
        return{

        }
    },
    mounted(){
       
    },
    methods:{
        
    },
    computed:{
        
    }
}
</script>

<style>

</style>